/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardFunnelDTO { 
    creata?: number;
    sottomessa?: number;
    presa_in_carico?: number;
    accettata?: number;
    rifiutata?: number;
}

